import { OnDestroy } from '@angular/core';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { CustomGridService } from '../../../../customgrid';
import { BObjectModel, InfoBo, InfoBoLink, InsertDocOption, QueovalBase, Select, TDOLien } from '../../../../models';
import { GenericEffectif } from '../../../../models/effectif/genericEffectif.model';
import { ModeEffectif,Option } from '../../../../models/effectif/option.model';
import { StageDocumentFormationModel, StageDocumentUpdate } from '../../../../models/formation';
import { CoreService, HttpService } from '../../../../services';
import { ToastService } from '../../../../toast';
import { StageService } from '../services/stage-modal.service';
import { DocumentService } from './document.service';


@Component({
  selector: 'queoval-stage-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css'],
  providers: [DocumentService]
})

export class DocumentComponent implements OnInit, OnDestroy {

  @ViewChild('ModalModifyDocument') modalModifyBo: ElementRef;
  @ViewChild('ModalReplaceDocument') modalReplaceDocument: ElementRef;

  constructor(
    public service: StageService,
    public docService: DocumentService,
    private customGridService: CustomGridService,
    private toast: ToastService,
    private modalService: NgbModal,
    protected http: HttpService,
    protected indParam: CoreService,
  ) { }

  public ShowDocument: boolean;
  public ShowCourrier: boolean;
  public ShowContrat: boolean;
  public effectifsSelectionnes: Array<InfoBoLink>;

  public ClientsSelected: Array<string> = [];
  public StagiairesSelected: Array<string> = [];
  public FormateursSelected: Array<string> = [];
  public ReservationsSelected: Array<string> = [];
  public FormateurSelected: string;
  
  public boDocModel: BObjectModel;

  public insertDocModel: BObjectModel;

  public refreshData: boolean = false;

  public customGridListenner: Subscription;
  public OptionClient: Option;
  public OptionStagiaire: Option;
  public OptionFormateur: Option;

  private GetLstIdents: Subscription;

  public selectedReport: Select = { id: 'Pas de génération', value: '0' };

  public ngOnInit(): void {
    this.insertDocModel = new BObjectModel();
    this.insertDocModel.Mode = 'CREATE';
    this.insertDocModel.Action = 'ANG_INSERT_DOC';
    this.insertDocModel.IdDonneeFils = '0';
    this.insertDocModel.IdDonneePere = this.service.Stage.Ident;
    this.insertDocModel.IdentBO = "BO_DOCUMENT";
    this.insertDocModel.CodeRelation = 'REL_BO_STAGE_BO_DOCUMENT';

    this.customGridListenner = this.customGridService.getItem().subscribe((data: any) => {

      //ident|BO|RELATION      
      const ident = data.Value;
      const boName = data.Bo ? data.Bo : 'BO_DOCUMENT';
      const relationName = data.Relation ? data.Relation : 'REL_BO_STAGE_BO_DOCUMENT';

      this.OptionClient = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.CLIENTMAIL, "UpdateDoc");
      this.OptionStagiaire = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.STAGIAIREMAIL, "UpdateDoc");
      this.OptionFormateur = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.FORMATEURMAIL, "UpdateDoc");
 
      switch (data.Action) {

        case 'OPENBO':
          this.boDocModel = new BObjectModel();
          this.boDocModel.IdentBO = this.docService.tabs[1].Active ? 'BO_COURRIER' : this.docService.tabs[2].Active ? 'BO_CNT' : boName;
          this.boDocModel.IdRelation = this.docService.tabs[1].Active ? 'REL_BO_STAGE_BO_COURRIER' : this.docService.tabs[2].Active ? 'REL_BO_STAGE_BO_CNT' : relationName;
          this.boDocModel.IdDonneePere = this.service.Stage.Ident;
          this.boDocModel.IdDonneeFils = ident;
          this.boDocModel.ShowSaveButton = true;

          if (boName == 'BO_DOCUMENT') {

            // Gestion des liens sur le bo document         

            const InfoBOLinkClient: InfoBo = new InfoBo();
            InfoBOLinkClient.IdDonneePere = "";
            InfoBOLinkClient.IdDonneeFils = ident;
            InfoBOLinkClient.IdRelation = 'REL_BO_CSOC_BO_DOCUMENT';

            const InfoBOLinkContact: InfoBo = new InfoBo();
            InfoBOLinkContact.IdDonneePere = "";
            InfoBOLinkContact.IdDonneeFils = ident;
            InfoBOLinkContact.IdRelation = 'REL_BO_CONTACT_BO_DOCUMENT';

            const InfoBOLinkFormateur: InfoBo = new InfoBo();
            InfoBOLinkFormateur.IdDonneePere = "";
            InfoBOLinkFormateur.IdDonneeFils = ident;
            InfoBOLinkFormateur.IdRelation = 'REL_BO_FORMATEUR_BO_DOCUMENT';

            // Appel pour recuperer les liens sur le document
            const lstClient: Observable<Array<string>> = this.docService.GetEffectifDocumentLink(InfoBOLinkClient);
            const lstContact: Observable<Array<string>> = this.docService.GetEffectifDocumentLink(InfoBOLinkContact);
            const lstFormateur: Observable<Array<string>> = this.docService.GetEffectifDocumentLink(InfoBOLinkFormateur);
            this.GetLstIdents = forkJoin([lstClient, lstContact, lstFormateur]).subscribe(
              (res: [Array<string>, Array<string>, Array<string>]) => {
                this.ClientsSelected = res[0];
                this.StagiairesSelected = res[1];
                this.FormateursSelected = res[2];

                this.ShowDocument = true;
                this.ShowCourrier = false;
                this.ShowContrat = false;

                this.effectifsSelectionnes = [];

                const infoListLienClient: InfoBoLink = new InfoBoLink();
                infoListLienClient.ListIdent = this.ClientsSelected;
                infoListLienClient.IdDonnee = ident;
                infoListLienClient.Origine = "PERE";
                infoListLienClient.IdRelation = 'REL_BO_CSOC_BO_DOCUMENT';
                this.effectifsSelectionnes.push(infoListLienClient);

                const infoListLienContact: InfoBoLink = new InfoBoLink();
                infoListLienContact.ListIdent = this.StagiairesSelected;
                infoListLienContact.IdDonnee = ident;
                infoListLienContact.Origine = "PERE";
                infoListLienContact.IdRelation = 'REL_BO_CONTACT_BO_DOCUMENT';
                this.effectifsSelectionnes.push(infoListLienContact);

                const infoListLienFormateur: InfoBoLink = new InfoBoLink();
                infoListLienFormateur.ListIdent = this.FormateursSelected;
                infoListLienFormateur.IdDonnee = ident;
                infoListLienFormateur.Origine = "PERE";
                infoListLienFormateur.IdRelation = 'REL_BO_FORMATEUR_BO_DOCUMENT';
                this.effectifsSelectionnes.push(infoListLienFormateur);

                this.OpenModal(this.modalModifyBo, true);
              });

          }
          else if (boName == 'BO_COURRIER') {


            // Gestion des liens sur le bo courrier         

            const InfoBOLinkClient: InfoBo = new InfoBo();
            InfoBOLinkClient.IdDonneePere = "";
            InfoBOLinkClient.IdDonneeFils = ident;
            InfoBOLinkClient.IdRelation = 'REL_BO_CSOC_BO_COURRIER';

            const InfoBOLinkContact: InfoBo = new InfoBo();
            InfoBOLinkContact.IdDonneePere = "";
            InfoBOLinkContact.IdDonneeFils = ident;
            InfoBOLinkContact.IdRelation = 'REL_BO_CONTACT_BO_COURRIER';

            const InfoBOLinkReservation: InfoBo = new InfoBo();
            InfoBOLinkReservation.IdDonneePere = ident;
            InfoBOLinkReservation.IdDonneeFils = "";
            InfoBOLinkReservation.IdRelation = 'REL_BO_COURRIER_BO_RESERV';

            // Report pour les statistiques
            this.selectedReport = { id: 'Pas de génération', value: '0' };
            // Appel pour recuperer les liens sur le document
            const lstClient: Observable<Array<string>> = this.docService.GetEffectifDocumentLink(InfoBOLinkClient);
            const lstContact: Observable<Array<string>> = this.docService.GetEffectifDocumentLink(InfoBOLinkContact);
            const lstReservation: Observable<Array<string>> = this.docService.GetEffectifDocumentLink(InfoBOLinkReservation);
            this.GetLstIdents = forkJoin([lstClient, lstContact, lstReservation]).subscribe(
              (res: [Array<string>, Array<string>, Array<string>]) => {
                this.ClientsSelected = res[0];
                this.StagiairesSelected = res[1];
                this.ReservationsSelected = res[2];

                // Courrier généré
                this.ShowDocument = false;
                this.ShowCourrier = true;
                this.ShowContrat = false;

                this.effectifsSelectionnes = [];

                const infoListLienClient: InfoBoLink = new InfoBoLink();
                infoListLienClient.ListIdent = this.ClientsSelected;
                infoListLienClient.IdDonnee = ident;
                infoListLienClient.Origine = "PERE";
                infoListLienClient.IdRelation = 'REL_BO_CSOC_BO_COURRIER';
                this.effectifsSelectionnes.push(infoListLienClient);

                const infoListLienContact: InfoBoLink = new InfoBoLink();
                infoListLienContact.ListIdent = this.StagiairesSelected;
                infoListLienContact.IdDonnee = ident;
                infoListLienContact.Origine = "PERE";
                infoListLienContact.IdRelation = 'REL_BO_CONTACT_BO_COURRIER';
                this.effectifsSelectionnes.push(infoListLienContact);

                const infoListLienReservation: InfoBoLink = new InfoBoLink();
                infoListLienReservation.ListIdent = this.ReservationsSelected;
                infoListLienReservation.IdDonnee = ident;
                infoListLienReservation.Origine = "FILS";
                infoListLienReservation.IdRelation = 'REL_BO_COURRIER_BO_RESERV';
                this.effectifsSelectionnes.push(infoListLienReservation);

                this.OpenModal(this.modalModifyBo, true);
              });

          }
          else if (boName == 'BO_CNT') {

            const InfoBOLinkReservation: InfoBo = new InfoBo();
            InfoBOLinkReservation.IdDonneePere = ident;
            InfoBOLinkReservation.IdDonneeFils = "";
            InfoBOLinkReservation.IdRelation = 'REL_BO_CNT_BO_RESERV';

            const InfoBOLinkFormateur: InfoBo = new InfoBo();
            InfoBOLinkFormateur.IdDonneePere = "";
            InfoBOLinkFormateur.IdDonneeFils = ident;
            InfoBOLinkFormateur.IdRelation = 'REL_BO_FORMATEUR_BO_CNT';

            const lstReservation: Observable<Array<string>> = this.docService.GetEffectifDocumentLink(InfoBOLinkReservation);
            const lstFormateur: Observable<Array<string>> = this.docService.GetEffectifDocumentLink(InfoBOLinkFormateur);
            this.GetLstIdents = forkJoin([lstReservation, lstFormateur]).subscribe(
              (res: [Array<string>, Array<string>]) => {

                this.ReservationsSelected = res[0];
                this.FormateurSelected = res[1] && res[1].length > 0 ? res[1][0] : '';

                // Contrat formateur genere
                this.ShowDocument = false;
                this.ShowCourrier = false;
                this.ShowContrat = true;

                this.effectifsSelectionnes = [];

                const infoListLienReservation: InfoBoLink = new InfoBoLink();
                infoListLienReservation.ListIdent = this.ReservationsSelected;
                infoListLienReservation.IdDonnee = ident;
                infoListLienReservation.Origine = "FILS";
                infoListLienReservation.IdRelation = 'REL_BO_CNT_BO_RESERV';
                this.effectifsSelectionnes.push(infoListLienReservation);

                this.OpenModal(this.modalModifyBo, true);
              });



          } else {
            this.ShowDocument = false;
            this.ShowCourrier = false;
            this.ShowContrat = false;

            this.OpenModal(this.modalModifyBo, true);
          }

          
          break;

        case 'REPLACEDOC':
          this.insertDocModel = new BObjectModel();
          this.insertDocModel.Mode = 'CREATE';
          this.insertDocModel.Action = 'ANG_INSERT_DOC';
          this.insertDocModel.IdDonneeFils = ident;
          this.insertDocModel.IdDonneePere = this.service.Stage.Ident;
          this.insertDocModel.IdentBO = this.docService.tabs[1].Active ? "BO_COURRIER" : this.docService.tabs[2].Active ? "BO_CNT" : boName;
          this.insertDocModel.CodeRelation = this.docService.tabs[1].Active ? 'REL_BO_STAGE_BO_COURRIER' : this.docService.tabs[2].Active ? 'REL_BO_STAGE_BO_CNT' : relationName;
          this.insertDocModel.IdRelation = this.docService.tabs[1].Active ? 'REL_BO_STAGE_BO_COURRIER' : this.docService.tabs[2].Active ? 'REL_BO_STAGE_BO_CNT' : relationName;
          this.OpenModal(this.modalReplaceDocument, false);
          break;
      }
    });
    this.docService.GetNiveauDocExtranet().subscribe();
  }

  public ngOnDestroy(): void {
    this.customGridListenner.unsubscribe();
}
  /** Evènement lors de l'insertion : rafraichir la grid + toast de succes
   * 
   * @param success boolean pour savoir si l'insertion a réussi
   */
  public OnInsert(success: boolean): void {
    if (success) {
      this.refreshGrid();
      this.toast.showSuccessToast('Document modifié', 3000);
    } else {
      this.toast.showWarningToast("La modification n'a pas réussi", 3000);
    }
  }

  public ActiveTab(indexType: number): void {
    this.docService.tabs.forEach(tab => {
      if (tab.Type === indexType && tab.Visible && !tab.Locked) {
        tab.Active = true;
      }
      else tab.Active = false;
    });
    if (this.docService.tabs.findIndex(t => t.Active) === -1) this.docService.tabs[0].Active = true;
  }

  /* 
 * Permet de recharger la grid
 */
  public refreshGrid(): void {
      this.refreshData = true;
  }

  /** Ouvrir une modal , la taille dépend du paramètre xl (vrai par default => modal taille q-xxl)
 * 
 * @param Modal la modal qui doit être ouverte
 * @param xl si oui la modal est grande, sinon elle est de taille réduite
 */
  public OpenModal(Modal: any, xl: boolean = true) {
    if (xl) {
      this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' });
    } else {
      this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
    }
  }


  /**
 * recupère la liste d'ident des effectifs par rapport
 * à l'Output du composant q-effectifs
 * @param event Liste d'ident des effectifs
 */
  public UpdateListEffectif(effectifs: Array<GenericEffectif>,  pRelation: string): void {
    const index:number = this.effectifsSelectionnes.findIndex(effectif => effectif.IdRelation == pRelation);

    const nouveauxSelectionnes: Array<string> = effectifs.filter(effectif => effectif.IsSelected)
      .map(effectif => {
        return effectif.Id;
      });
    if (index != -1)
      this.effectifsSelectionnes[index].ListIdent = nouveauxSelectionnes;
  }

  /**
  * recupère la liste d'ident des réservations par rapport
  * à l'Output du composant ListReservationComponent
  * @param event Liste d'ident des reservations
  */
  public UpdateListeReservations(event: Array<string>, pRelation: string): void {
    const index: number = this.effectifsSelectionnes.findIndex(effectif => effectif.IdRelation == pRelation);

    if (index != -1)
      this.effectifsSelectionnes[index].ListIdent = event;     
  }

  // Sauvegarde du BO
  // Enregistrement des liens aprés la sauvegarde du BO document, courrier, contrat
  // Recalcul du montant du contrat
  // Demande de re generation de document du courrier ou du contrat
  public getEvent(model: BObjectModel, Modal: any): void {
    if (model.NameBO == 'BO_DOCUMENT' || model.NameBO == 'BO_COURRIER' || model.NameBO == 'BO_CNT') {
      this.docService.PostUpdateEffectifLink(this.effectifsSelectionnes).subscribe(
        (res: boolean) => {
          if (model.NameBO == 'BO_CNT') {
            this.docService.UpdateMontantContrat(this.boDocModel.IdDonneeFils).subscribe(
              (res: boolean) => {
                this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
              });
          }
          else if (model.NameBO == 'BO_COURRIER') {
            this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
          }            
        });
    }
  }



  /*
* Regénération des documents selectionnés
*/
  public RegenereDocStat() {

    if (this.selectedReport.value !== '0') {
      //Regeneration des statistiques
      let documentFormationModel: StageDocumentFormationModel = new StageDocumentFormationModel();
      documentFormationModel.IdDocument = this.boDocModel.IdDonneeFils
      documentFormationModel.IdReport = this.selectedReport.value;
      documentFormationModel.IdStage = this.service.Stage.Ident;
      documentFormationModel.Stagiaires = this.StagiairesSelected;
      documentFormationModel.Clients = this.ClientsSelected;
      this.http.postHttp<QueovalBase>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/GENERATE_STATISTIQUE`, documentFormationModel).subscribe(
        (result: QueovalBase) => {
          if (!result.HasError) {
            this.RegenereDoc();
          }
        });
    } else {
      this.RegenereDoc();
    }
  }

  public RegenereDoc() {
    let documentModel = new StageDocumentUpdate();
    documentModel.DocumentIdentList = new Array<string>();    
    documentModel.DocumentIdentList.push(this.boDocModel.IdDonneeFils);
    
    documentModel.StringData = this.service.Stage.Ident;
    documentModel.TypeDocument = "COURRIER";
    this.http.postHttp<QueovalBase>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/GENERATE_DOC`, documentModel).subscribe(
      (result: QueovalBase) => {
        if (!result.HasError) {
          this.toast.showSuccessToast("Document(s) généré(s)");                    
        }
        this.indParam.showSplash(false);
      });
  }
  //#endregion Fonctions Publics

}
